export default __webpack_public_path__ + "assets/audios/game-success.mp3";